import React from "react";
import { ref, deleteObject } from "firebase/storage";
import { storage } from "../../../firebase";
import { Button } from "../../../design/button";
import { TrashIcon } from "@heroicons/react/16/solid";
import { ClientFile } from "@visitproof/types";
import { useSupervisor } from "../../../contexts/SupervisorContext";
import { useDeleteAlert } from "../../../contexts/DeleteAlertProvider";

type File = ClientFile;

interface DeleteFileButtonProps {
  supervisorId: string;
  file: File;
}

const DeleteSupervisorFileButton: React.FC<DeleteFileButtonProps> = ({
  supervisorId,
  file,
}) => {
  const { deleteFileFromSupervisor } = useSupervisor();
  const { openAlert } = useDeleteAlert();

  const handleDelete = async (id: string) => {
    const fileRef = ref(storage, file.path);
    await deleteObject(fileRef);
    await deleteFileFromSupervisor(supervisorId, id);
  };

  const handleClick = () => {
    openAlert(
      file,
      {
        displayName: "file",
        onDelete: handleDelete,
        getId: (entity) => entity.id,
      }
    );
  };

  return (
    <Button type="button" onClick={handleClick}>
      <TrashIcon className="w-5 h-5" aria-hidden="true" />
    </Button>
  );
};

export default DeleteSupervisorFileButton;
